import React from 'react';
import { View } from 'react-native';
import Typography from '../../../components/Text/Text';
import Checkbox from '../../../components/Checkbox/Checkbox';
import Divider from '../../../components/Divider/Divider';
import { styles } from '../screens/Policy/PolicyScreen.styles';

export interface EndorsementsState {
  blanketAdditionalInsured: boolean;
  waiverOfSubrogation: boolean;
  hiredNonOwnedAuto: boolean;
  nonOwnedTrailer: boolean;
}

interface EndorsementsSectionProps {
  endorsements: {
    values: EndorsementsState;
    setValues: (updater: (prev: EndorsementsState) => EndorsementsState) => void;
  };
}

const EndorsementsSection: React.FC<EndorsementsSectionProps> = ({ endorsements }) => {
  const handleChange = (key: keyof EndorsementsState, checked: boolean) => {
    endorsements.setValues((prev) => ({ ...prev, [key]: checked }));
  };

  return (
    <View style={styles.checkboxContainer}>
      <Typography variant="title2" style={styles.label}>
        Endorsements & Options
      </Typography>
      <View style={styles.checkboxItem}>
        <Checkbox
          active={endorsements.values.blanketAdditionalInsured}
          onChange={(checked) => handleChange('blanketAdditionalInsured', checked)}
        />
        <Typography variant="body1">Blanket Additional Insured</Typography>
      </View>
      <Divider />
      <View style={styles.checkboxItem}>
        <Checkbox
          active={endorsements.values.waiverOfSubrogation}
          onChange={(checked) => handleChange('waiverOfSubrogation', checked)}
        />
        <Typography variant="body1">Waiver of Subrogation</Typography>
      </View>
      <Divider />
      <View style={styles.checkboxItem}>
        <Checkbox
          active={endorsements.values.hiredNonOwnedAuto}
          onChange={(checked) => handleChange('hiredNonOwnedAuto', checked)}
        />
        <Typography variant="body1">Hired/Non-Owned Auto</Typography>
      </View>
      <Divider />
      <View style={styles.checkboxItem}>
        <Checkbox
          active={endorsements.values.nonOwnedTrailer}
          onChange={(checked) => handleChange('nonOwnedTrailer', checked)}
        />
        <Typography variant="body1">Non-Owned Trailer</Typography>
      </View>
      <Divider />
    </View>
  );
};

export default EndorsementsSection;
